import type { QueryKey } from '@tanstack/react-query';

export const USER_PROFILE_KEY = (userId: string): QueryKey => [
  `user-profile-${userId}`,
];
